module.exports = __webpack_public_path__ + "img/business-energy.9620dcf.png";